// Candidate bio description as template literal for easy markdown editing
// This approach makes it much easier to edit markdown content with proper syntax highlighting

export const candidateBio = `**Sdr. Faisha Sudarlin** yang akrab dengan panggilan **mas Fa** memulai tugas sebagai tenaga pelayan gerejawi di GKJ Pamulang sejak tanggal **10 Juni 2018**, setelah itu diangkat sebagai karyawan tetap di GKJ Pamulang per **1 September 2020**. Saat ini yang bersangkutan juga menjadi majelis gereja dengan jabatan **Penatua** membawahi bidang Kesaksian dan Pelayanan.

### Awal Pelayanan

Di awal pelayanannya, mas Fa menjalankan tugas-tugas gerejawi antara lain:

* Melatih musik bagi pemandu/pengiring lagu pujian
* Melatih paduan suara untuk beberapa kategorial seperti: **Adiyuswa**, **KPR**, dan **jemaat dewasa/wilayah**
* Bertugas sebagai pemandu/pengiring lagu pujian

### Perkembangan Pelayanan

Dalam perkembangannya, **Mas Fa** juga menjalankan tugas gerejawi lainnya, yakni sebagai **pembawa firman** baik dalam ibadah minggu ataupun ibadah lainnya.

### Kehidupan Pribadi

Saat ini mas Fa telah berkeluarga menikah dengan Sdri. Nuke Elok Haryanto

### Keputusan Pencalonan

Dengan memperhatikan hasil jajak pendapat dengan jemaat terhadap pencalonan mas Fa sebagai pendeta GKJ Pamulang, maka berdasarkan **Keputusan No.: KEP-05/MG/GKJP/III/2025**, tanggal **25 Maret 2025**, Majelis telah memutuskan **Sdr. Pnt. Faisha Sudarlin, M.Th.** Sebagai calon tunggal untuk calon **Pendeta kedua GKJ Pamulang**.`;